import React, { useState, useCallback, lazy, Suspense, useRef } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

// Material Icons

// React CSV
import { CSVLink } from 'react-csv';

// Actions
import { setOpen, setClose } from 'store/ducks/dialogs/actions';
import {
  emtuReportRequest,
  setSelectedStartDate,
  setSelectedEndDate,
} from 'store/ducks/reports/actions';
import * as ReportActions from 'store/ducks/reports/actions';

// Types
import {
  EmtuReportDataInterface,
} from 'store/ducks/reports/types';
import { ApplicationState } from 'store';

// Components
import { MainContent, SearchComponent, ReportTitle } from 'components';
import { TablePlaceholder } from 'components/TablePlaceholder';
import { TabPanel } from 'components/TabPanel';

// Constants
import { REPORTS_TYPES } from 'constants/report';
import ITEMS from 'constants/itemsByFilter';
import TITLES_OPTIONS from 'constants/infoModulesTitle';
import { Submissions, History } from '../../../../components';

// Styles
import useStyles from './emtuReport.styles';

// Lazy Components
const TableEmtuReport = lazy(() =>
  import('./components/TableEmtuReport/TableEmtuReport'),
);
const Filter = lazy(() => import('components/Filter'));
const TotalCountComponent = lazy(() =>
  import('components/TotalCountComponent'),
);

interface EmtuReportDatailsProps {
  setSubmissionData: (param: any) => void;
  setIsAddSubmissiion: (param: any) => void;
  setIsEditSubmissiion: (param: any) => void;
}

const EmtuReportDatails: React.FC<EmtuReportDatailsProps> = ({
  setSubmissionData,
  setIsAddSubmissiion,
  setIsEditSubmissiion,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const csvRef = useRef(null);

  const [reportIsVisible, setReportIsVisible] = useState(false);
  const [tableReference, setTableReference] = useState(null);
  const [tableCSV, setTableCSV] = useState('');
  const [generalNavGuide, setGeneralNavGuide] = useState(0);
  const [emtuList, setEmtuList] = useState<EmtuReportDataInterface[]>([]);

  const emtuReportList = useSelector(
    (state: ApplicationState) => state.reports.emtuReportList,
  );

  console.log({ emtuReportList });

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setGeneralNavGuide(newValue);
  };

  const handleLoadData = useCallback(() => {
    setReportIsVisible(true);

    // initial date
    const MS_DAY = 86400000; // 1Day in ms
    const now = new Date();
    const yest = new Date(now.getTime() - MS_DAY);

    dispatch(
      emtuReportRequest({
        startDate: new Date().setHours(0, 0, 0),
        endDate: new Date().setHours(23, 59, 59),
      }),
    );

    dispatch(
      setSelectedStartDate({
        selectedStartDate: yest,
      }),
    );
    dispatch(
      setSelectedEndDate({
        selectedEndDate: now,
      }),
    );
  }, [dispatch]);

  const handleApply = useCallback(
    ({ startDate, endDate, startedAt }: any) => {
      dispatch(setClose({}));
      setReportIsVisible(true);

      if (!reportIsVisible) setReportIsVisible(true);

      const isPeriod = startDate?.getTime() < endDate?.getTime();

      if (isPeriod) {
        dispatch(
          ReportActions.setSelectedStartDate({
            selectedStartDate: startDate,
          }),
        );
        dispatch(
          ReportActions.setSelectedEndDate({
            selectedEndDate: endDate,
          }),
        );
      }

      dispatch(
        emtuReportRequest({
          startDate: isPeriod
            ? new Date(startDate).getTime()
            : new Date(startedAt).setHours(0, 0, 0),
          endDate: isPeriod
            ? new Date(endDate).getTime()
            : new Date(startedAt).setHours(23, 59, 59),
        }),
      );
    },
    [dispatch, reportIsVisible],
  );

  return (
    <div className={classes.root}>
      <MainContent className={classes.paperRoot}>
        <Grid ref={(node: any) => setTableReference(node)}>
          <Grid
            container
            justifyContent='space-between'
            className={classes.gridContainer}>
            <Grid item>
              <ReportTitle
                titleVariant='h4'
                title='Relatórios de Usuários • Saldo'
                tooltipTitle={TITLES_OPTIONS.REPORTS.USER.BALANCE.VALUE}
              />
            </Grid>
            <Grid item className={classes.icons}>
              {reportIsVisible && (
                <Grid item>
                  <CSVLink
                    filename='emtu-report.csv'
                    data={tableCSV}
                    ref={csvRef}>
                    <Tooltip title='Baixar CSV' placement='right' arrow>
                      <IconButton />
                    </Tooltip>
                  </CSVLink>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid container className={classes.chipFilter}>
            <Box
              display='flex'
              alignItems='center'
              width='100%'
              marginTop='8px'>
              <SearchComponent
                disabledInput={!reportIsVisible}
                data={emtuReportList.data}
                itemsByFilter={ITEMS.ReportEmtu}
                results={(data: any[]) => setEmtuList(data)}
                modalFilter={() => {
                  dispatch(
                    setOpen({
                      open: true,
                      content: (
                        <Suspense fallback={<p>Carregando...</p>}>
                          <Filter
                            fields={ITEMS.emtu.remote}
                            handleApply={handleApply}
                          />
                        </Suspense>
                      ),
                      maxWidth: 'xl',
                    }),
                  );
                }}
              />
              {/* <Grid container justifyContent='flex-end'>
                <Button
                  className={classes.addButton}
                  onClick={() => setIsAddSubmissiion(true)}>
                  <Typography style={{ marginRight: 8, fontSize: 20 }}>
                    +
                  </Typography>{' '}
                  <Typography style={{ fontSize: 12 }}>
                    Programar Novo
                  </Typography>
                </Button>
              </Grid> */}
            </Box>
          </Grid>
          <Tabs
            indicatorColor='primary'
            onChange={handleChange}
            style={{
              background: '#ffffff',
              margin: '10px 0px 32px 16px',
            }}
            textColor='primary'
            value={generalNavGuide}>
            <Tab label='Relatório' />
            <Tab label='Envios' />
            <Tab label='Histórico' />
          </Tabs>
          <TabPanel index={0} value={generalNavGuide}>
            {reportIsVisible && emtuReportList?.data?.length > 0 && (
              <Box width='100%' display='flex' justifyContent='flex-end' mr={4}>
                <Suspense fallback='Carregando...'>
                  <TotalCountComponent
                    count={emtuReportList?.data?.length || 0}
                    title='usuários'
                    position='right'
                  />
                </Suspense>
              </Box>
            )}

            {!reportIsVisible && <TablePlaceholder onClick={handleLoadData} />}
            {reportIsVisible && (
              <Suspense fallback={<p>Carregando...</p>}>
                <TableEmtuReport
                  setTableCSV={setTableCSV}
                  csvRef={csvRef}
                  tableReference={tableReference}
                  emtuList={emtuList}
                />
              </Suspense>
            )}
          </TabPanel>
          <TabPanel index={1} value={generalNavGuide}>
            <Submissions
              setSubmissionData={setSubmissionData}
              setIsEditSubmissiion={setIsEditSubmissiion}
              reportType={REPORTS_TYPES.USER_VALUES}
            />
          </TabPanel>{' '}
          <TabPanel index={2} value={generalNavGuide}>
            <History reportType={REPORTS_TYPES.USER_VALUES} />
          </TabPanel>
        </Grid>
      </MainContent>
    </div>
  );
};

export default EmtuReportDatails;
export { EmtuReportDatails };
